import { Component } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { NodeService } from '../../Services/api-nodeservice';
import { Api } from '../../Model/api-model';
import { Router } from '@angular/router';

@Component({
  selector: 'announcement-support-private',
  templateUrl: './announcement-private.component.html'
})
export class AnnouncementPrivateComponent{

    constructor(private nodeService: NodeService,private router: Router) { 
      localStorage.setItem("is_cuurent_nav_aem","y");
    }

    ngAfterViewInit() {
      window.scroll(0,0);
    
        
         }

}